import React from 'react';
import Warning from 'ui/Icons/warning.component.svg';
import FluidButton from 'ui/FluidButton';
import { theme } from '../../../tailwind.config';
import { _format, tDateString } from 'utils/date';
import * as DateUtilsUtc from 'utils/date.utc';

interface IHoldCheckModalItem {
  roomName: string;
  startDate: string;
  endDate: string;
  guestAges: {
    numberOfAdults: number;
    agesOfAllChildren?: number[];
  };
}

interface IHoldCheckModalProps {
  items: IHoldCheckModalItem[];
  onClose: () => void;
}

export const HoldCheckModal: React.FC<IHoldCheckModalProps> = ({ items, onClose }) => {
  return (
    <div className="flex flex-col items-center py-[20px] px-[40px] gap-[20px] max-w-[480px]">
      <div className="w-[36px] h-[36px]">
        <Warning fill={theme.colors['gray-40']} />
      </div>

      <span className="block text-[16px] leading-[20px] font-bold font-hurmegeometric-sans text-black text-center">
        The accommodation(s) can't be held at this time as there is either no availability or the Hotel is not offering this option during these stay dates.
      </span>

      <div className="w-full max-h-[300px] overflow-y-auto pb-[10px]">
        <div className="flex flex-col gap-[15px]">
          {items.map((item, index) => {
            const numberOfChildren = item.guestAges.agesOfAllChildren?.length ?? 0;
            const adultsText = `${item.guestAges.numberOfAdults} Adults`;
            const childrenText =
              numberOfChildren > 0 ? ` / ${numberOfChildren} ${numberOfChildren === 1 ? 'Child' : 'Children'}` : '';

            return (
              <div key={`${item.roomName}-${index}`} className="flex flex-col gap-[3px]">
                <span className="block text-[13px] font-bold font-hurmegeometric-sans text-flint uppercase">
                  {item.roomName}
                </span>
                <span className="block text-[14px] font-bold font-hurmegeometric-sans text-brown-hard uppercase">
                  {adultsText}
                  {childrenText}
                </span>
                <span className="block text-[12px] font-hurmegeometric-sans text-flint uppercase">
                  {_format(item.startDate as tDateString, 'd MMM yy')} - {_format(DateUtilsUtc.addDays(item.endDate, 1) as tDateString, 'd MMM yy')}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <FluidButton
        type="primary"
        className="w-[200px] h-[40px] font-semibold font-hurmegeometric-sans rounded-none uppercase"
        onClick={onClose}
      >
        OK
      </FluidButton>
    </div>
  );
};
